import React, { useState, useEffect, useRef, useContext } from "react";
import {
    ContentWrapper,
    SnackbarContent,
    PageTitle,
    SVGContainer,
    TTBody
} from "../styled-components/shared";
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import "./Playsound.css"
import Snackbar from "@material-ui/core/Snackbar";
import styled from "styled-components";
import firebaseUtil from "../data/FirebaseUtil";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import DropdownCustom from '../components/DropdownCustom';

import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { withStyles } from '@material-ui/core/styles';

import { AuthContext } from "../authentication/Auth";
import app from "../authentication/firebaseStart";
import BottomNavLinks from "../components/BottomNavLinks";
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { PlaySoundService } from "../Services/PlaySoundService";
import { TENANT_ID } from "../data/application.properties";

const firestore = app.firestore();


const StyledContentWrapper = styled(ContentWrapper)`
  padding: 10px;
`;

const ButtonContainer = styled.div`
    display: inline;
    max-width: 500px;
    justify-content: initial;
    margin-top:20px
`;

const StyledTextField = styled(TextField)`
  display: flex;
  width: 100%;

  input{
  padding: 9px !important;

      &:focus{
        border-color:#2684FF !important;
    }
  }

  & .MuiOutlinedInput-root {
      &.Mui-focused fieldset {
        border-color: #2684FF !important;
      }
    }

`;


const ErrorMsg = styled.p`
    margin: 0;
    padding-left: 10px;
    font-size: 0.75rem;
    margin-top: 3 px;
    text-align: left;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    color: red;
`;

const StyledOnDiv = styled.div`
  margin-left: 65px;
`;


const CheckboxComp = styled.label`
    display: flex;
    align-items: center;
    margin-left: -10px;
`;


export default function LostDevicePage({setSnackbarOpen, serverResponse}) {
    const DEFAULT_MAXRSSI = -100;
    const context = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation()
    const [enableSwitch, setEnableSwitch] = useState(false);
    const [anyOneChanged, setAnyOneChanged] = useState(false);
    const [error, setError] = React.useState(false);
    //const [helperText, setHelperText] = React.useState('Choose wisely');
    const [isPageLoading, setPageLoading] = useState(false);
    const defaultAudio = {label:`${t('deviceTracker')} 1`,value:'Device Tracker 1.mp3'};
    const [enableAudio, setEnableAudio] = useState(false);
    const [enableLED, setEnableLED] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState(t('lostDeviceNearbyNotifications.defaultNotificationMsg'));
    const [maxRssi, setMaxRssi] = useState(DEFAULT_MAXRSSI);
    const [playSoundType, setPlaySoundType] = useState(0);
    const [customAudioToneText, setCustomAudioToneText] = useState("");
    const [deviceSound, setDeviceSound] = useState([{ label: defaultAudio.label, value: defaultAudio.value }]);
    const [customTone,setCustomTone]=useState("");
   
    /**
     * Preloaded sound tracks are hardcoded, it was discussed and implemented. 
     * If need more option, will need code changes
     */
    const [deviceSoundArr, setDeviceSoundArr] = useState([
        { label: `${t('deviceTracker')} 1` , value: "Device Tracker 1.mp3" },
        { label: `${t('deviceTracker')} 2`, value: "Device Tracker 2.mp3" },
        { label: `${t('deviceTracker')} 3`, value: "Device Tracker 3.mp3" },
        { label: `${t('deviceTracker')} 4`, value: "Device Tracker 4.mp3" },
        { label: `${t('deviceTracker')} 5`, value: "Device Tracker 5.mp3" },

    ]);

    const [replayInterval, setReplayInterval] = useState([{ label: "4 sec", value: 4 }]);
    const [replayIntervalArr, setReplayIntervalArr] = useState([
        { label: t('none'),   value: 0  },
        { label: "4 sec",  value: 4 },
        { label: "6 sec",  value: 6 },
        { label: "8 sec",  value: 8 },
        { label: "10 sec", value: 10 },
        { label: "12 sec", value: 12},
        { label: "14 sec", value: 14 }

    ]);

    const [volumeLevel, setVolumeLevel] = useState([{ label: "100%", value: 100 }]);
    const [volumeLevelArr, setVolumeLevelArr] = useState([
        { label: "20%",  value: 20 },
        { label: "40%",  value: 40 },
        { label: "60%",  value: 60 },
        { label: "80%",  value: 80 },
        { label: "100%", value: 100 },
    ]);

    const [audioCustom, setaudioCustom] = useState(false)
    const errors = useRef([]);
    const [checkErrors, setCheckErrors] = useState(false);
    const [audioDurationValue, setAudioDurationValue] = useState(0);
    const companyID = context.currentUser.claims.companyID;

    const onClickCancelBtn = () => {
        setAnyOneChanged(false);
        getSettings();
    }

    useEffect(() => {
        getSettings();
    }, []);
    
    useEffect(()=>{
        if(audioDurationValue === 0){
            setReplayInterval([{ label: t('none'), value: 0 }])
        }
    },[audioDurationValue])

    async function getSettings() {
        try{
            let companyID = context.currentUser.claims.companyID;
            const service = new PlaySoundService();
            setIsLoading(true);
            const data = await service.getPlaySoundSetting(companyID);
            setIsLoading(false);
            console.log("playSoundSetting", data)
            if (data) {

                setPlaySoundType(data.playSoundType);
                if (data.playSoundType === 0) {
                    setDeviceSound([{ label: defaultAudio.label, value: defaultAudio.value }])
                } else if (data.playSoundType === 1) {
                    /**
                     * replace(/\.[^/.]+$/, "") used to replace extension of file regex is faster way
                    */
                    let label = data.audioFileOnDevice.replace(/\.[^/.]+$/, "")
                    setDeviceSound([{ label: label, value: data.audioFileOnDevice }])
                }
                setCustomTone(data.audioCustomTone)
    
                if (data.audioInterval) {
                    if(data.audioInterval === 0){
                        setReplayInterval([{ label: t('none'), value:data.audioInterval  }])
                    }else{
                        let interval = data.audioInterval + ' sec'
                        setReplayInterval([{ label: interval, value: data.audioInterval }])
                    }
                }
    
                if (data.volumeLevel) {
                    let volume = data.volumeLevel + '%';
                    setVolumeLevel([{ label: volume, value: data.volumeLevel }])
                }
    
                if (data.audioDuration) {
                    setAudioDurationValue(data.audioDuration)
                }
            }
        }catch(err){
            setSnackbarOpen(true);
            serverResponse.current = err;
            setIsLoading(false);
            
        }
        
    }

    async function handleSaveChanges() {
        errors.current = [];  

        if(customTone.length === 0 && playSoundType === 2){
            setCheckErrors(!checkErrors);
            errors.current = errors.current.concat("customToneError");
            console.log(errors.current)
            return;
        }

        let data = {
            deviceSound: deviceSound[0].value,
            volumeLevel: volumeLevel[0].value,
            replayInterval: replayInterval[0].value,
            playSoundType: playSoundType,
            audioFileOnDevice:deviceSound[0].value,
            replayDuration: audioDurationValue,
            audioCustomTone:customTone

        };
        const service = new PlaySoundService();
        setIsLoading(true);
        service.addPlaySoundSetting(companyID, data);
        setIsLoading(false);
        setSnackbarOpen(true);
        setAnyOneChanged(false);
        serverResponse.current = {status:true,msg:"Settings Saved Successfully"};
        console.log("data is", data)
    }

    const onClickResetBtn = () => {
        setAnyOneChanged(true);
        setPlaySoundType(0);
        setDeviceSound([{ label: defaultAudio.label, value: defaultAudio.value }]);
        setVolumeLevel([{ label: "100%", value: 100 }]);
        setReplayInterval([{ label:t('none'), value: 0 }])
        setAudioDurationValue(0)
        setCustomTone("")

    }



    const onDeviceTrackerSoundChange = (audio) => {
        let label = audio.replace(/\.[^/.]+$/, "");
        let value = audio;
        setDeviceSound([{ label: label, value: value }])
        setAnyOneChanged(true);
    }
    const onAudioChange = (audioIntervalValue) => {
        if(audioIntervalValue === 0){
            setReplayInterval([
                { label:t('none'), value: audioIntervalValue }
            ]);
        }else{
            setReplayInterval([
                { label: audioIntervalValue +' sec', value: audioIntervalValue }
            ]);
        }
        setAnyOneChanged(true);
    }

    const onVolumeLevelChange = (volumeLevelValue) => {
        setVolumeLevel([
            { label: volumeLevelValue+'%', value: volumeLevelValue }
        ]);
        setAnyOneChanged(true);
    }

    const playSoundTypeChange = (event) => {
        setAnyOneChanged(true);
        setPlaySoundType(parseInt(event.target.value))
        setaudioCustom(!audioCustom);
    }
    const changeAudioDuration = (duration) => {
        setAudioDurationValue(audioDurationValue + duration);
        setAnyOneChanged(true)
    }

    return (
        <div style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1' }}>
            <h3>{t('playSoundNotification.PlaySound')}</h3>
            <div
                style={{
                    display: isPageLoading ? "flex" : "none",
                    justifyContent: "left"
                }}
            >
                <CircularProgress />
            </div>
            <FormGroup className="play-sound-form-grp" >
                <div>
                
                    <Checkbox
                        disabled
                        color="primary"
                        checked={true}
                        id='audio'
                        
                    />
                    <label className='playsound-audio' for="audio">{t('playSoundNotification.audio')}</label><br></br>

                </div>
                
                <div className="playsound-radio-format-control">
                    <FormControl component="fieldset" 
                    fullWidth
                    >
                        <RadioGroup id = 'play-sound' aria-label="play-sound-type" name="play-sound-type" value={playSoundType}
                            onChange={(e) => {
                                playSoundTypeChange(e)
                            }
                            }>
                            <FormControlLabel value={0}
                                control={
                                    <Radio color="primary" id='system-default' />
                                }
                                label={t('btScannersNotifications.systemDefault')}
            
                            />
                            <FormControlLabel value={1}
                                control={

                                    <Radio color="primary" id='device-tracker-sound' />
                                }
                                label={t('playSoundNotification.deviceTrackerSound')}
                                
                            />
                            <div className="lost-device-vibrate-pattern pay-sound-custom-dropdwn" style={{ paddingLeft: 30 }}>

                                <DropdownCustom
                                    selectVal={deviceSound}
                                    selectOpts={deviceSoundArr}
                                    onChange={(e) => onDeviceTrackerSoundChange(e.target.value)}
                                    isDisabled={playSoundType === 0?true:false}

                                />
                            </div>

                            <FormControlLabel value={2}
                                control={

                                    <Radio color="primary" id='custom-tone' />
                                }
                                label={t('playSoundNotification.deviceTrackerSound')}
                                
                            />
                            <div className="lost-device-vibrate-pattern pay-sound-custom-dropdwn" style={{ paddingLeft: 30 }}>

                                <StyledTextField
                                    value = {customTone}
                                    variant="outlined"
                                    onChange={e=>{setAnyOneChanged(true);setCustomTone(e.target.value)}}
                                    disabled={playSoundType != 2?true:false}
                                    placeholder={t('mlTimeoutPage.customTonePlaceholder')}
                                />
                                 {errors.current.includes("customToneError") ? (<ErrorMsg>{t('playSoundNotification.errorMsg1')}</ErrorMsg>):null}
                            </div>
                           
                        </RadioGroup>


                    </FormControl>

                </div>
                


                <div className="playsound-format-control">
                    <FormControl fullWidth>
                        <p id="volume-level-tag" className="playsound-label">{t('playSoundNotification.volumeLevel')}</p>
                        <div className="lost-device-vibrate-pattern pay-sound-custom-dropdwn" >
                            <DropdownCustom
                                selectVal={volumeLevel}
                                id='volume-level'
                                selectOpts={volumeLevelArr}
                                onChange={(e) => onVolumeLevelChange(e.target.value)}
                                label="volume level"

                            />
                        </div>

                    </FormControl>

                </div>
                
                <div className="playsound-format-control">
                    <FormControl fullWidth>
                        <p id="demo-simple-select-label-3" className="playsound-label">{t('playSoundNotification.playDuration')}</p>
                        <p className="play-sound-desciption">{t('playSoundNotification.selectPlayTimeRepeat')}</p>
                        <div style={{ display: 'flex', flexDirection: "row" }}>
                            <Button 
                                variant="outlined"
                                onClick={() => {
                                    if (audioDurationValue != 0){
                                        changeAudioDuration(-1)
                                    }   
                                }}
                                disabled={audioDurationValue ===0?true:false}
                            >
                                <RemoveIcon></RemoveIcon>
                            </Button>
                            <TextField
                                style={{ margin: "0 5px" }}
                                fullWidth
                                value={audioDurationValue === 0? t('none'):audioDurationValue+' Min'}
                                variant="outlined"
                                id='replay-duration'
                                inputProps={{
                                    style: {
                                        height: 5,
                                        textAlign: 'center'
                                    },
                                    readOnly: true,
                                
                                }}
                                inputStyle={{textAlign: 'center', cursor: 'none' }}
                            />
                            <Button 
                                variant="outlined"
                                onClick={() => {
                                    if (audioDurationValue < 20)
                                    changeAudioDuration(1)
                                }}
                                disabled={audioDurationValue ===20?true:false}
                            >
                                <AddIcon></AddIcon>
                            </Button>
                        </div>

                    </FormControl>

                </div>
                
                <div className="playsound-format-control">
                    <FormControl  fullWidth>
                        <p id="replay-interval-label" className="playsound-label">{t('playSoundNotification.repeatIntreval')}</p>
                        <p className="play-sound-desciption">{t('playSoundNotification.selectDelayBetweenRepeats')}</p>
                        <div className="lost-device-vibrate-pattern pay-sound-custom-dropdwn" >
                            <DropdownCustom
                                selectVal={replayInterval}
                                selectOpts={replayIntervalArr}
                                id="replay-interval"
                                onChange={(e) => onAudioChange(e.target.value)}
                                isDisabled={audioDurationValue === 0 ? true:false}
                            />
                        </div>
                    </FormControl>

                </div>
                
            </FormGroup>
            <ButtonContainer>
                <Button
                    onClick={() => onClickResetBtn()}
                    color='secondary'
                    style={{ backgroundColor: "rgb(117, 117, 117)", margin: 8, borderRadius: 0, fontSize: "0.909091rem", textTransform: "none" }}
                    variant="contained"
                >
                    {t('lostDeviceNearbyNotifications.Reset to default')}
                </Button>
            </ButtonContainer>
            {anyOneChanged &&
                <ButtonContainer>

                    <Button
                        onClick={() => onClickCancelBtn()}
                        style={{ border: "2px solid gray", color: "black", borderRadius: 0, fontSize: "0.909091rem", textTransform: "none" }}
                        variant="outlined"

                    >
                        {t('cancel')}
                    </Button>
                    <Button
                        onClick={handleSaveChanges}
                        variant="outlined"
                        style={{ border: "1px solid rgba(0, 122, 186)", background: "rgba(0, 122, 186)", color: "white", margin: 8, borderRadius: 0, fontSize: "0.909091rem", textTransform: "none" }}
                    >
                        {t('save')}
                    </Button>
                </ButtonContainer>
            }
            <BottomNavLinks />
        </div>
    );
}